import { ref } from 'vue'

export const global = ref({
    url: "https://bookingeasy.ru/api/",
    //url: "http://localhost:2222/",
    //?url=http://localhost:2222/
    authenticated: false,
    lk: false,
    account:{key:"ключ(появится после входа в личный кабинет)",botKey:"(появится после входа в личный кабинет)", subjects:[]}
});